import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'     // ✅ 3.x 版本用这个

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Antd)
})
